import { unregisterPushNotificationsAsync } from '@/services/pushNotifications';
import { authStore } from '@/stores/auth.store';

/**
 * Sign out of this device: drop its push token (best-effort, never throws)
 * before clearing the session so the signed-out user stops receiving pushes.
 * Shared by the Profile tab's "Sign out" and the onboarding escape hatch.
 *
 * The onboarding case matters more than it looks: expo-secure-store lives in
 * the iOS Keychain, which survives deleting and reinstalling the app. A phone
 * that once signed in as a friend whose PIN-created account never finished
 * its profile keeps that token forever, so every launch lands on "Your
 * profile" for an account that isn't the user's — and reinstalling doesn't
 * reset it. Signing out is the only way off that screen.
 */
export async function signOutThisDevice(): Promise<void> {
  await unregisterPushNotificationsAsync();
  await authStore.logout();
}
